import { action,observable,computed,toJS } from 'mobx'

export default class LehrplanStore {

  @observable competenceSteps = []
  @observable lehrplan

  @action.bound init (lehrplan,preSelection) {
    if (!this.lehrplan) {
     this.lehrplan = lehrplan
     this.clearCompetenceSteps()
    }
    if (preSelection) this.preSelection = preSelection
  }

  @action clearCompetenceSteps () {
    this.competenceStepFilter = []
  }

  @computed get hasCompetenceSteps () {
    return this.competenceSteps && this.competenceSteps.length > 0
  }

  getChipData () {
   let temp = []
   let arr = this.competenceSteps
   if (!arr|| arr.length === 0) return temp

   for (let i = 0; i < this.lehrplan.length; i++) {
     let kompetenz = this.lehrplan[i]
     for (let j = 0; j < kompetenz.kompetenzstufen.length; j++) {
       let kompetenzStufe = kompetenz.kompetenzstufen[j]
       for (let k = 0; k < arr.length; k++) {
         let filter = arr[k]
         if (kompetenzStufe.id === filter) {
           temp.push(kompetenzStufe)
         }
       }
     }
   }

   return temp
  }

  getKompetenzByIndex (index) {
    if (this.lehrplan) {
     return this.lehrplan[index]
    }
  }

  @action.bound toggleCompetenceStep (id,cb) {
    if (!this.isActiveCompetenceStep(id)) {
     this.addCompetenceStep(id)
    } else {
     this.removeCompetenceStep(id)
   }
   if (cb) cb(this.competenceSteps)
  }

  isActiveCompetenceStep (id) {
    for (let i = 0; i < this.competenceSteps.length; i++) {
      if (this.competenceSteps[i] === id) {
        return true
      }
    }
    return false
  }

  @action addCompetenceStep (id) {
    this.competenceSteps.push(id)
  }

  @action removeCompetenceStep (id) {
    this.competenceSteps = this.competenceSteps.filter( (item) => {
     if (item !== id) {
       return item
     }
    })
  }


}



// WEBPACK FOOTER //
// ./src/stores/lehrplan.js